import React from "react";
import { FaCapsules, FaSyringe, FaHospitalAlt, FaHeartbeat } from "react-icons/fa";

const products = [
  { title: "Tablets & Capsules", icon: <FaCapsules size={40} /> },
  { title: "Injectables", icon: <FaSyringe size={40} /> },
  { title: "IV Fluids", icon: <FaHospitalAlt size={40} /> },
  { title: "Critical Care Medicines", icon: <FaHeartbeat size={40} /> },
];

function Products() {
  return (
    <section id="products" className="section-padding bg-light">
      <div className="container text-center">
        <h2 className="fw-bold mb-5">Our Product Portfolio</h2>
        <p className="text-muted">Leocord supplies a comprehensive range of pharmaceutical products designed to meet the needs of hospitals and healthcare providers. Our product portfolio includes essential medicines sourced from trusted manufacturers and verified suppliers to ensure safety, quality, and compliance with healthcare standards.</p>
        <p className="text-muted pb-4">Leocord supplies a comprehensive range of pharmaceutical products designed to meet the needs of hospitals and healthcare providers. Our product portfolio includes essential medicines sourced from trusted manufacturers and verified suppliers to ensure safety, quality, and compliance with healthcare standards.</p>
        <div className="row g-4">
          {products.map((item, index) => (
            <div className="col-md-3" key={index}>
              <div className="card premium-card h-100 p-4 text-center">
                <div className="text-primary mb-3">{item.icon}</div>
                <h5 className="fw-semibold">{item.title}</h5>
                <p className="text-muted small mt-2">
                  Manufactured in GMP-compliant facilities ensuring highest standards.
                </p>
                <button className="btn btn-outline-primary btn-sm mt-3">
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;